export const AC_PACKAGES = ['Basis', 'PlussLite', 'PlussStor', 'Signatur'];

export function hasPackageChoice(packageChoice) {
	return AC_PACKAGES.includes(packageChoice);
}

export function showsExtendedPackageFields(packageChoice) {
	return (
		packageChoice === 'PlussLite' ||
		packageChoice === 'PlussStor' ||
		packageChoice === 'Signatur'
	);
}

export const TARGETING_FIELDS = [
	'malGeo',
	'geoAge',
	'wishesDemands',
	'skillsTitles',
	'companies',
	'industryInterests',
	'hybridHome',
];

export const AD_CREATIVE_TYPES = ['stillbildevideo', 'animatedAd'];

export const EXTENDED_ONLY_FIELDS = [
	'feed-text',
	'adCreativeType',
	'stillbildevideo',
	'animatedAd',
	'stillbildevideo-slide1',
	'stillbildevideo-slide2',
	'stillbildevideo-slide3',
	'lastPoster',
	'geoAge',
	'wishesDemands',
	'skillsTitles',
	'companies',
	'industryInterests',
	'hybridHome',
	'storyText',
];

export const CHECKBOX_EXTENDED_FIELDS = ['hybridHome'];

function isTruthyFlag(value) {
	return (
		value === true ||
		value === 'true' ||
		value === 'on' ||
		value === '1' ||
		value === 1
	);
}

export function resolveAdCreativeType(data) {
	if (!data || typeof data !== 'object') {
		return '';
	}
	if (AD_CREATIVE_TYPES.includes(data.adCreativeType)) {
		return data.adCreativeType;
	}
	const still = isTruthyFlag(data.stillbildevideo);
	const animated = isTruthyFlag(data.animatedAd);
	if (still) {
		return 'stillbildevideo';
	}
	if (animated) {
		return 'animatedAd';
	}
	return '';
}

export function normalizeAdCreativeChoice(data) {
	if (!data || typeof data !== 'object') {
		return data;
	}
	const next = { ...data };
	const type = resolveAdCreativeType(next);
	delete next.adCreativeType;

	if (type === 'stillbildevideo') {
		next.stillbildevideo = true;
		delete next.animatedAd;
		return next;
	}
	if (type === 'animatedAd') {
		next.animatedAd = true;
		delete next.stillbildevideo;
		delete next['stillbildevideo-slide1'];
		delete next['stillbildevideo-slide2'];
		delete next['stillbildevideo-slide3'];
		return next;
	}

	delete next.stillbildevideo;
	delete next.animatedAd;
	delete next['stillbildevideo-slide1'];
	delete next['stillbildevideo-slide2'];
	delete next['stillbildevideo-slide3'];
	return next;
}

export const PACKAGE_ALLOWED_SERVICES = {
	Basis: [{ id: 'jobbkarusell', name: 'Jobbkarusell Fra 2600,-' }],
	PlussLite: [],
	PlussStor: [],
	Signatur: [
		{ id: 'podcast', name: 'Podcast' },
		{ id: 'innhold', name: 'Innhold' },
	],
};

export function targetingFieldsForPackage(packageChoice) {
	if (showsExtendedPackageFields(packageChoice)) {
		return TARGETING_FIELDS;
	}
	return ['malGeo'];
}

export function pruneAdditionalServices(packageChoice, selectedServices) {
	if (!selectedServices || typeof selectedServices !== 'object') {
		return {};
	}
	if (!packageChoice) {
		return { ...selectedServices };
	}
	const allowed = PACKAGE_ALLOWED_SERVICES[packageChoice];
	if (!allowed) {
		return { ...selectedServices };
	}
	if (allowed.length === 0) {
		return {};
	}
	const next = {};
	for (const [key, service] of Object.entries(selectedServices)) {
		const matches = allowed.some(
			(entry) =>
				entry.id === key ||
				entry.name === key ||
				entry.id === service?.id ||
				entry.name === service?.name
		);
		if (matches) {
			next[key] = service;
		}
	}
	return next;
}

export function visibleOrderData(data) {
	if (!data || typeof data !== 'object') {
		return data;
	}
	let next = { ...data };
	if (!showsExtendedPackageFields(next.packageChoice)) {
		for (const key of EXTENDED_ONLY_FIELDS) {
			delete next[key];
		}
	} else {
		next = normalizeAdCreativeChoice(next);
	}
	if (next.packageChoice) {
		next.additionalServices = pruneAdditionalServices(
			next.packageChoice,
			next.additionalServices
		);
		if (Object.keys(next.additionalServices).length === 0) {
			delete next.additionalServices;
			delete next.servicesColumnList;
		}
	}
	return next;
}

export const AC_LOCATIONS = [
	'Oslo',
	'Hamar',
	'Trondheim',
	'Molde',
	'Ålesund',
	'Stavanger',
];

export const AC_REQUIRED_FIELDS = [
	'companyName',
	'ordererName',
	'ordererEmail',
	'ordererPhone',
	'stillingstittel',
	'packageChoice',
];
